.title {
  font: var(--text-headline);
  letter-spacing: var(--tracking-headline);
  color: var(--label);
}

.detail {
  margin-top: var(--space-2);
  font: var(--text-callout);
  color: var(--label-2);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin-top: var(--space-4);
}

.signedOut {
  display: grid;
  min-height: 100dvh;
  place-items: center;
  padding: var(--space-4);
}

.signedOut > * {
  width: min(360px, 100%);
}

.card {
  display: grid;
  gap: var(--space-3);
  justify-items: start;
}

.signedOut .title {
  font: var(--text-title-3);
  letter-spacing: var(--tracking-title-3);
}

.mark {
  color: var(--ink);
}
